// src/socket.js
import { io } from 'socket.io-client';

// Don’t connect yet — we’ll attach the slug & fire .connect() from within your Dashboard components.
const socket = io({
  autoConnect: false,
  // (optional) you can pass transports or path here if you’ve customized them:
  // transports: ['websocket'],
  // path: '/socket.io'
});

export default socket;
